<template>
  <div class="app-container"> 
        <el-form :model="queryParams" ref="queryForm" label-width="auto" :inline="true" style="overflow: hidden; clear: both;">
          <el-form-item label="服务编号" class="f-item">
            <el-input
             style="width: 300px;"
              v-model="queryParams.serviceNo"
              placeholder="请输入服务编号"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="公告名称" class="f-item">
            <el-input
              style="width: 300px;"
              v-model="queryParams.noticeName"
              placeholder="请输入公告名称"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="证书编号" class="f-item">
            <el-input
             style="width: 300px;"
              v-model="queryParams.certificateNo"
              placeholder="请输入证书编号"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="提交时间">
              <el-date-picker
                  style="width: 300px"
                  format="yyyy-MM-dd" 
                  value-format="yyyy-MM-dd"
                  placeholder="请选择"
                  v-model="submitTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
          </el-form-item>
          <el-form-item label="上链时间">
              <el-date-picker
                  style="width: 300px"
                  format="yyyy-MM-dd" 
                  value-format="yyyy-MM-dd"
                  placeholder="请选择"
                  v-model="blockchainDate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
          </el-form-item>
          <el-form-item label="当前状态" prop="status">
              <el-select v-model="queryParams.status" placeholder="请选择当前状态" clearable size="small">
              <el-option
                  v-for="dict in stateOptions"
                  :key="dict.dictValue"
                  :label="dict.dictLabel"
                  :value="dict.dictValue"
              ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="服务类型" prop="serviceType">
              <el-select v-model="queryParams.serviceType" placeholder="请选择服务类型" clearable size="small">
              <el-option
                  v-for="dict in serviceOptions"
                  :key="dict.dictValue"
                  :label="dict.dictLabel"
                  :value="dict.dictValue"
              ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item >
            <el-button type="orange" size="mini" @click="handleQuery">搜索</el-button>
            <el-button size="mini" @click="resetQuery" style="padding:0 15px;">重置</el-button>
          </el-form-item>
        </el-form>
        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button
              type="orange"
              icon="el-icon-plus"
              size="mini"
              @click="handleAddC"
            >新建公示公告服务</el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button
              type="orange"
              icon="el-icon-s-order"
              size="mini"
              @click="downloadFile"
            >服务文件下载</el-button>
          </el-col>
          <!-- <el-col :span="1.5">
            <el-button
              type="warning"
              icon="el-icon-download"
              size="mini"
              @click="handleExport"
            >导出</el-button>
          </el-col> -->
        </el-row>

    <el-table v-loading="loading" stripe :data="arbitrateRecords">
      <el-table-column  type="index" label="序号" width="70" align="center"/>
      <el-table-column label="服务编号" align="center" prop="serviceNo" min-width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.status != '0'">{{ scope.row.serviceNo }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="服务类型" align="center" prop="serviceType" width="160" :formatter="serviceFormat"></el-table-column>
      <el-table-column label="证书编号" align="center" prop="certificateNo" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.status == '5' || scope.row.status == '9'">{{ scope.row.certificateNo }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="公告名称" align="center" prop="noticeName" min-width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.serviceType == '41' || scope.row.serviceType == '43'">{{ scope.row.noticeName }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="公告所涉金额（万元）" align="center" prop="noticeRelateAmount" width="160">
        <template slot-scope="scope">
          {{setComdify(scope.row.noticeRelateAmount, 4)}}
				</template>
			</el-table-column>
      <el-table-column label="共识金额（万元）" align="center" prop="consensusAmount" width="160">
        <template slot-scope="scope">
          {{setComdify(scope.row.consensusAmount, 4)}}
				</template>
			</el-table-column>
      <el-table-column label="提交时间" align="center" prop="submitTime" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.status != '0'">{{ scope.row.submitTime }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="通告查询码" align="center" prop="checkCode" width="110">
        <template slot-scope="scope">
          <span v-if="scope.row.status == '5' || scope.row.status == '9'">{{ scope.row.checkCode }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="上链时间" align="center" prop="blockchainDate" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.status == '5' || scope.row.status == '9'">{{ scope.row.blockchainDate }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="当前状态" align="center" prop="status" width="160" :formatter="stateFormat"></el-table-column>
      <el-table-column label="通告状态" align="center" width="160" prop="noticeStatus">
        <template slot-scope="scope">
          <span v-if="scope.row.status == '5' || scope.row.status == '9'">
            {{ noticeStatusFormat(scope.row) }}
          </span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="190" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <span class="f-blue" v-if="scope.row.status != '0'" @click="goDetail(scope.row)">详情</span>
          <span class="f-blue" v-if="scope.row.status == '0' || scope.row.status == '2' || scope.row.status == '4' || scope.row.status == '7'" style="margin-left: 10px;" @click="handleEdit(scope.row)">编辑</span>
          <span class="f-blue" v-if="scope.row.status == '0' || scope.row.status == '2' || scope.row.status == '4' || scope.row.status == '7'" style="margin-left: 10px;" @click="handleDel(scope.row)">删除</span>
          <span class="f-blue" v-if="scope.row.status != '0' && scope.row.status != '5'" @click="preview(scope.row)" style="margin-left: 10px;">预览链证报告</span>
          <span class="f-blue" v-if="scope.row.status == '5'" @click="download(scope.row)" style="margin-left: 10px;">下载链证报告</span>
          <span class="f-blue" v-if="scope.row.status == '5' && scope.row.noticeStatus == '1'" @click="handleStatus(scope.row, '2')" style="margin-left: 10px;">隐藏通告</span>
          <span class="f-blue" v-if="scope.row.status == '5' && scope.row.noticeStatus == '2'" @click="handleStatus(scope.row, '1')" style="margin-left: 10px;">显示通告</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="toolbar">
        <el-pagination class="b-orange" background layout="prev, pager, next" @current-change="handleCurrentChange" :current-page.sync="queryParams.pageNum" :page-size="queryParams.pageSize" :total="total">
        </el-pagination>
    </div>

  </div>
</template>

<script>
import baseUrl from '@/api/baseUrl.js'
import { download } from "@/api/utils";
export default {
  name: "contract",
  components: {

  },
  data() {
    return {
      setComdify: this.comdify,
      loading: true,
      checkLoading: null,
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      submitTime: [],
      blockchainDate: [],
      total: 0,
      arbitrateRecords: [],
      account: sessionStorage.account,
      idNo: '',
      companyType: '',
      serviceOptions: [],
      stateOptions: [],
      noticeStatusOptions: [],
      checkParams: {
        platform: 4,
      }
    }
  },
  watch: {
      // 监听路由变化
      "$route.query": function(newVal, oldVal) {
          this.queryParams = {
            pageNum: 1,
            pageSize: 10,
          }
          this.getList()
      }
  },
  created() {
    this.$api.api.getDicts("gsgg_state").then(response => {
        this.stateOptions = response.data;
    });
    this.$api.api.getDicts("gsgg_service_type").then(response => {
        this.serviceOptions = response.data;
    });
    this.$api.api.getDicts("notice_tatus").then(response => {
        this.noticeStatusOptions = response.data;
    });
    this.getList()
    this.getInf()
  },
  methods: {
    goDetail(row){
      this.$router.push(`/ADetail?id=${row.id}`);
    },
    selectDictLabel(datas, value) {
      var actions = [];
      Object.keys(datas).some((key) => {
        if (datas[key].dictValue == ('' + value)) {
          actions.push(datas[key].dictLabel);
          return true;
        }
      })
      return actions.join('');
    }, 
    serviceFormat (row) {
      return this.selectDictLabel(this.serviceOptions, row.serviceType);
    }, 
    stateFormat (row) {
      return this.selectDictLabel(this.stateOptions, row.status);
    },  
    noticeStatusFormat (row) {
      return this.selectDictLabel(this.noticeStatusOptions, row.noticeStatus);
    },  
    getInf(){
      this.$api.api.iaccGetInfoByAccount({account: this.account}).then(response => {
        this.companyType = response.data.companyType
        this.idNo = response.data.idNo
        this.checkParams.projectName = response.data.companyCn
        this.checkParams.socialCode = response.data.job
        sessionStorage.projectName = response.data.companyCn
        sessionStorage.socialCode = response.data.job
        sessionStorage.applyCustomerName = response.data.applyCustomerName
        sessionStorage.applyCustomerContact = response.data.applyCustomerContact
        sessionStorage.applyCustomerAccount = response.data.applyCustomerAccount
      });
    },
    handleCurrentChange(val) { // 查询list
      this.queryParams.pageNum = val;
      this.getList();
    }, 
    getList() {
      if(this.submitTime){
        this.queryParams.submitStartTime = this.submitTime[0]
        this.queryParams.submitEndTime = this.submitTime[1]
      }
      if(this.blockchainDate){
        this.queryParams.blockchainStartDate = this.blockchainDate[0]
        this.queryParams.blockchainEndDate = this.blockchainDate[1]
      }
      this.queryParams.createBy = this.account;
      let queryParams = Object.assign({}, this.queryParams);
      this.$api.announcement.anList(queryParams).then(response => {
        this.loading = false
        if(response.code==200){
          this.arbitrateRecords = response.rows;
          this.total = response.total;
        }else {
          this.$message.error(response.msg);
        }    
      });
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10
      }
      this.submitTime=[]
      this.blockchainDate= []
      this.handleQuery();
    },
    preview(row){
      this.reportDownload(baseUrl.iaccUrl + '/iacc-contract-platform/contract/notice/project/contractReportPreview/'+row.id,
      `contractReportPreview_${new Date().getTime()}.pdf`)
    },
    download(row){
      this.reportDownload(baseUrl.iaccUrl + '/iacc-contract-platform/contract/notice/project/contractReport/'+row.id+'?response-content-type=application/octet-stream', 
      `contractReport_${new Date().getTime()}.pdf`)
    },
    handleAddC(){
      this.checkLoading = this.$loading({
        lock: true,
        text: "查询中",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // 判断黑名单
      this.$api.api.checkInBlacklist(this.checkParams).then(res => {
        if(res.code == '00000000') {
          if(res.content.checkResult){
            this.checkLoading.close();
            this.$alert('黑名单企业禁入，如有疑问联系数据方处理', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                return false
              }
            });
          }else{
            //灰名单
            this.$api.api.checkInGreylist(this.checkParams).then(res => {
              this.checkLoading.close();
              if(res.contentGrey.checkResult){
                this.$alert('灰名单企业，请关注业务风险，可做存储', '提示', {
                  confirmButtonText: '确定'
                });
              }       
            });
            sessionStorage.removeItem("setpForm")
            this.$router.push({path: '/addAnnouncement'}); 
          }
        }else {
          this.checkLoading.close();
          this.$message.error(res.msg)
        }
        
      });      
    },    
    handleEdit(row){
      sessionStorage.removeItem("setpForm")
      this.$router.push(`/addAnnouncement?id=${row.id}`);
    },
    handleDel(row){
      this.$confirm("确定删除此条公示公告服务吗？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$api.announcement.delAn(row.id).then(response => {
          if(response.code==200){
            this.$message.success("删除成功！")
            this.getList();
          }else {
            this.$message.error(response.msg);
          }    
        });
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      const queryParams = this.queryParams;
      this.$confirm("确定导出此存证信息吗？", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          return this.$api.announcement.exportAn(queryParams);
        }).then(response => {
          this.download(response.msg);
        })
    },
    downloadFile(){
      this.$api.api.serviceFile('4')
    },
    handleStatus(row, displayStatus){
      this.$confirm("确定修改此公告状态吗？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$api.announcement.editAn({id: row.id, displayStatus}).then(response => {
          if(response.code==200){
            this.$message.success("修改成功！")
            this.getList();
          }else {
            this.$message.error(response.msg);
          }    
        });
      }).then(response => {
        this.download(response.msg);
      })
    }
  }
}
</script>

<style>
.wrap{word-wrap:break-word; word-break:break-all;}
.el-button:focus, .el-button:hover{
  color: #DDB642;
  border-color: #DAA513;
  background-color: #F7F1DF;
}
</style>
